// extracted by mini-css-extract-plugin
export default {"wrapper":"chat-01_wrapper__U7D2I","boxSaasImg":"chat-01_boxSaasImg__a2GMQ","boxTitle":"chat-01_boxTitle__iIrZJ","textWithLogo":"chat-01_textWithLogo__3-Wnn"};